import { U } from "@angular/cdk/keycodes";

export const URLEndpoints = {
  SetStudentPaper: {
    AllotStudentPaperPreferenceBasedOnQuota: 'SetStudentPaper/AllotStudentPaperPreferenceBasedOnQuota',
    ReadPreferenceSetQuota: 'SetStudentPaper/ReadPreferenceSetQuota',
    AllotStudentPaperPreferenceBasedOnGeneralQuota: 'SetStudentPaper/AllotStudentPaperPreferenceBasedOnGeneralQuota',
  },
  InstitutionMaster: {
    ReadSettingbyInstitutionID: 'InstitutionMaster/ReadSettingbyInstitutionID',
  },
  StudentOtherDetails: {
    ReadStudentExperientialLearningRecords: 'StudentOtherDetails/ReadStudentExperientialLearningRecords',
    UpdateStudentExperientialLearningRecords: 'StudentOtherDetails/UpdateStudentExperientialLearningRecords'
  },
  StudentTransportation: {
    ReadBoardingPointRate: 'StudentTransportation/ReadBoardingPointRate',
    UpdateBoardingPointRate: 'StudentTransportation/UpdateBoardingPointRate',
    ReadStudentBoardingPoint: 'StudentTransportation/ReadStudentBoardingPoint',
    InsertStudentBoardingPoint: 'StudentTransportation/InsertStudentBoardingPoint',
    ReadBoardingPointBusTrips: 'StudentTransportation/ReadBoardingPointBusTrips',
    ReadStudentBoardingPointDetails: 'StudentTransportation/ReadStudentBoardingPointDetails',
    ReadBoardingPointVehicles: 'StudentTransportation/ReadBoardingPointVehicles',
    UpdateStudentBoardingPoint: 'StudentTransportation/UpdateStudentBoardingPoint',
    DeleteStudentBoardingPoint: 'StudentTransportation/DeleteStudentBoardingPoint',
    InsertVehicleLogDetails: 'StudentTransportation/InsertVehicleLogDetails',
    ReadVehicleLogDetails: 'StudentTransportation/ReadVehicleLogDetails',
    UpdateVehicleLogDetails: 'StudentTransportation/UpdateVehicleLogDetails',
    DeleteVehicleLogDetails: 'StudentTransportation/DeleteVehicleLogDetails',
    ReadStudCountInARouteOnADate: 'StudentTransportation/ReadStudCountInARouteOnADate',
    ReadVehiclesInARouteOnADate: 'StudentTransportation/ReadVehiclesInARouteOnADate',
    ReadNonRunningVehiclesOnADate: 'StudentTransportation/ReadNonRunningVehiclesOnADate',
    ReadNonRunningDriversOnADate: 'StudentTransportation/ReadNonRunningDriversOnADate',
    ReadNonRunningAssistanceOnADate: 'StudentTransportation/ReadNonRunningAssistanceOnADate',
    UpdateVehicleLogDetailsDaily: 'StudentTransportation/UpdateVehicleLogDetailsDaily',
    ReadStudentsForUpdateTransportationDetails: 'StudentTransportation/ReadStudentsForUpdateTransportationDetails',
    UpdateStudentTransportationDetails: 'StudentTransportation/UpdateStudentTransportationDetails',
    ReadStudentCountsOnBoardingPoints: 'StudentTransportation/ReadStudentCountsOnBoardingPoints',
    InsertVehicleLogDetailsDaily: 'StudentTransportation/InsertVehicleLogDetailsDaily',
    ReadTransportationStudCountClassWiseOnADate: 'StudentTransportation/ReadTransportationStudCountClassWiseOnADate',
    UpdateTransportationAcademicDayStatus: 'StudentTransportation/UpdateTransportationAcademicDayStatus', 
    DeleteVehicleLogDetailsDaily: 'StudentTransportation/DeleteVehicleLogDetailsDaily', 

  },
  LookUpMaster: {
    ReadbyModule: 'LookUpMaster/ReadbyModule',
  },
  PapersInClassStaffDetails: {
    ReadPapersInClassDataForStaffChange: 'PapersInClassStaffDetails/ReadPapersInClassDataForStaffChange',
    UpdatePapersInClassDataForStaffChange: 'PapersInClassStaffDetails/UpdatePapersInClassDataForStaffChange',
    ReadPaperbyStaff: 'PapersInClassStaffDetails/ReadPaperbyStaff'
  },
  TimeTableGroup: {
    ReadTTGroupDataForStaffChange: 'TimeTableGroup/ReadTTGroupDataForStaffChange',
    UpdateTTGroupDataForStaffChange: 'TimeTableGroup/UpdateTTGroupDataForStaffChange',
  },
  TimeTable: {
    ReadTimeTableDataForStaffChange: 'TimeTable/ReadTimeTableDataForStaffChange',
    UpdateTimeTableDataForStaffChange: 'TimeTable/UpdateTimeTableDataForStaffChange'
  },
  Paper: {
    ReadPaperPrerequisiteGroup: 'Paper/ReadPaperPrerequisiteGroup',
    UpdatePaperPrerequisiteGroup: 'Paper/UpdatePaperPrerequisiteGroup',
    DeletePaperPrerequisiteGroup: 'Paper/DeletePaperPrerequisiteGroup',

  },

  ExamMaster: {
    ExamRegistrationLogin: 'ExamMaster/ExamRegistrationLogin',
    ReadExaminationForExternalApply: 'ExamMaster/ReadExaminationForExternalApply',
    ReadPaperDetailsForExternalExamApply: 'ExamMaster/ReadPaperDetailsForExternalExamApply',
    UpdateExternalExamRegistration: 'ExamMaster/UpdateExternalExamRegistration',
    ReadStudentCondonationAllSemDetails: 'ExamMaster/ReadStudentCondonationAllSemDetails',
    ReadStudentEnrollmentDetails: 'ExamMaster/ReadStudentEnrollmentDetails',
    ReadStudentAddressDetails: 'ExamMaster/ReadStudentAddressDetails',
    UpdateStudentAddress: 'ExamMaster/UpdateStudentAddress',
    ReadStudentCountForBundling: 'ExamMaster/ReadStudentCountForBundling',
    ReadQPforBundling: 'ExamMaster/ReadQPforBundling',
    IssueQPBundling: 'ExamMaster/IssueQPBundling',
    ReturnQPBundling: 'ExamMaster/ReturnQPBundling',
    ReadBundlingDetails: 'ExamMaster/ReadBundlingDetails',
    ReadCurrentController: 'ExamMaster/ReadCurrentController',
    ReadPaperForValuationDutyAssign: 'ExamMaster/ReadPaperForValuationDutyAssign',
    ReadPaperForChiefSetup: 'ExamMaster/ReadPaperForChiefSetup',
    ReadChairmanPanel: 'ExamMaster/ReadChairmanPanel',
    GetStudentsForValuationBundling: 'ExamMaster/GetStudentsForValuationBundling',
    UpdateChairmanPanel: 'ExamMaster/UpdateChairmanPanel',
    AllotStudentForValuation: 'ExamMaster/AllotStudentForValuation',
    ReadChiefPanel: 'ExamMaster/ReadChiefPanel',
    ReadExamForChiefSetup: 'ExamMaster/ReadExamForChiefSetup',
    GetStudentsForAssignChief: 'ExamMaster/GetStudentsForAssignChief',
    GetStudentsForAssignExaminer: 'ExamMaster/GetStudentsForAssignExaminer',
    UpdateStudentsToChiefAndChiefPanel: 'ExamMaster/UpdateStudentsToChiefAndChiefPanel',
    UpdateStudentsToExaminerAndExaminerPanel: 'ExamMaster/UpdateStudentsToExaminerAndExaminerPanel',
    ReadExaminerPanel: 'ExamMaster/ReadExaminerPanel',
    ReadExamForValuation: 'ExamMaster/ReadExamForValuation',
    ReadPaperForValuation: 'ExamMaster/ReadPaperForValuation',
    ReadStudentsConsolidatedMarkDetails: 'ExamMaster/ReadStudentsConsolidatedMarkDetails',
    UpdateStudentOBEConsolidatedMarkEntry: 'ExamMaster/UpdateStudentOBEConsolidatedMarkEntry',
    UpdateStudentOBEMarkEntry: 'ExamMaster/UpdateStudentOBEMarkEntry',
    UpdateStudentOBEMarkEntrySubmission: 'ExamMaster/UpdateStudentOBEMarkEntrySubmission',
    ReadLevelForValuation: 'ExamMaster/ReadLevelForValuation',
    ReadStudentsOBEExamDetailedMarkDetails: 'ExamMaster/ReadStudentsOBEExamDetailedMarkDetails',
    ReadPaperListForQPBundling: 'ExamMaster/ReadPaperListForQPBundling',
    ReadRevaluationStudentsConsolidatedMarkDetails: 'ExamMaster/ReadRevaluationStudentsConsolidatedMarkDetails',
    GetRevaluationStudentsForAssignChief: 'ExamMaster/GetRevaluationStudentsForAssignChief',
    ReadExamForChiefSetupForRevaluation: 'ExamMaster/ReadExamForChiefSetupForRevaluation',
    GetStudentsForRevaluationBundling: 'ExamMaster/GetStudentsForRevaluationBundling',
    ReadChairmanPanelForRevaluation: 'ExamMaster/ReadChairmanPanelForRevaluation',
    ReadPaperForChiefSetupForRevaluation: 'ExamMaster/ReadPaperForChiefSetupForRevaluation',
    ReadPaperForRevaluationDutyAssign: 'ExamMaster/ReadPaperForRevaluationDutyAssign',
    ReadRevaluationPaperForFalseNoGeneration: 'ExamMaster/ReadRevaluationPaperForFalseNoGeneration',
    ReadChiefPanelForRevaluation: 'ExamMaster/ReadChiefPanelForRevaluation',
    ReadExamForRevaluation: 'ExamMaster/ReadExamForRevaluation',
    GetStudentsForAssignExaminerForRevaluation: 'ExamMaster/GetStudentsForAssignExaminerForRevaluation',
    ReadLevelForRevaluation: 'ExamMaster/ReadLevelForRevaluation',
    ReadPaperForRevaluation: 'ExamMaster/ReadPaperForRevaluation',
    ReadStudentsRevaluationOBEExamDetailedMarkDetails: 'ExamMaster/ReadStudentsRevaluationOBEExamDetailedMarkDetails',
    UpdateStudentRevaluationOBEConsolidatedMarkEntry: 'ExamMaster/UpdateStudentRevaluationOBEConsolidatedMarkEntry',
    UpdateRevaluationStudentOBEMarkEntrySubmission: 'ExamMaster/UpdateRevaluationStudentOBEMarkEntrySubmission',
    UpdateRevaluationStudentOBEMarkEntry: 'ExamMaster/UpdateRevaluationStudentOBEMarkEntry',
    ReadRevaluationSetupMaster: 'ExamMaster/ReadRevaluationSetupMaster',
    UpdateRevaluationSetup: 'ExamMaster/UpdateRevaluationSetup',
    ReadExaminationForRevaluationExternalApply: 'ExamMaster/ReadExaminationForRevaluationExternalApply',
    ReadPaperDetailsForRevaluationApply: 'ExamMaster/ReadPaperDetailsForRevaluationApply',
    ReadSeatAllotmentDetailsForStaffDutyAssign:'ExamMaster/ReadSeatAllotmentDetailsForStaffDutyAssign',
    ReadAllotmentDetailsForBundling:'ExamMaster/ReadAllotmentDetailsForBundling',
    ReadExamMaster: 'ExamMaster/ReadExamMaster',
    AutoIssueQPBundling: 'ExamMaster/AutoIssueQPBundling',
    ReadGraceMarksRules: 'ExamMaster/ReadGraceMarksRules',
    UpdateGraceMarksRules: 'ExamMaster/UpdateGraceMarksRules',
    DeleteGraceMarksRules: 'ExamMaster/DeleteGraceMarksRules',
    ReadExpertListForInvigilationDuty: 'ExamMaster/ReadExpertListForInvigilationDuty',
    ReadInvigilationDutyRejectedList: 'ExamMaster/ReadInvigilationDutyRejectedList',
    ReadGraceMarkApplication: 'ExamMaster/ReadGraceMarkApplication',
    UpdateGraceMarkApplication: 'ExamMaster/UpdateGraceMarkApplication',
    DeleteGraceMarkApplication: 'ExamMaster/DeleteGraceMarkApplication',
    ReadPaperForModeration: 'ExamMaster/ReadPaperForModeration',
    ReadSubjectsForModeration: 'ExamMaster/ReadSubjectsForModeration',
    ReadGraceMarkApplicationList: 'ExamMaster/ReadGraceMarkApplicationList',
    ApproveOrRejectGraceMarkApplication: 'ExamMaster/ApproveOrRejectGraceMarkApplication',
    ReadStudentMarksForGraceMarkApplicationDetails: 'ExamMaster/ReadStudentMarksForGraceMarkApplicationDetails',
    UpdateGraceMarkApplicationDetails: 'ExamMaster/UpdateGraceMarkApplicationDetails',

  },

  PrincipalDashboard: {
    ReadStaffCountDepartmentWise: 'PrincipalDashboard/ReadStaffCountDepartmentWise',
    ReadTimetableToday: 'PrincipalDashboard/ReadTimetableToday',
    ReadGeneralDetailsCount: 'PrincipalDashboard/ReadGeneralDetailsCount',
    ReadUnmarkedHourCount: 'PrincipalDashboard/ReadUnmarkedHourCount',
    ReadUnMarkedStaffHourDetails: 'PrincipalDashboard/ReadUnMarkedStaffHourDetails',
    ReadAttendanceShortageList: 'PrincipalDashboard/ReadAttendanceShortageList',
    ReadPOEnterAndNonEnteredDetails: 'PrincipalDashboard/ReadPOEnterAndNonEnteredDetails',
    ReadCOEnteredCountDetails: 'PrincipalDashboard/ReadCOEnteredCountDetails',
    ReadCOEnterAndNonEnteredDetails: 'PrincipalDashboard/ReadCOEnterAndNonEnteredDetails',
    ReadStaffLeaveDetails: 'PrincipalDashboard/ReadStaffLeaveDetails',
    ReadStaffLeaveCount: 'PrincipalDashboard/ReadStaffLeaveCount',
    ReadStaffLeaveCountLeaveTypeWise: 'PrincipalDashboard/ReadStaffLeaveCountLeaveTypeWise',
    ReadStaffWorkloadCount: 'PrincipalDashboard/ReadStaffWorkloadCount',
    ReadStaffWorkloadDetails: 'PrincipalDashboard/ReadStaffWorkloadDetails',
    ReadStaffDetails: 'PrincipalDashboard/ReadStaffDetails',
    ReadUnmarkedWorkDiary: 'PrincipalDashboard/ReadUnmarkedWorkDiary',
    ReadFeeCollectionDetails: 'PrincipalDashboard/ReadFeeCollectionDetails',
    ReadFeeCollectionDetailsCourseWise: 'PrincipalDashboard/ReadFeeCollectionDetailsCourseWise',
    ReadFeeCollectionDetailsClassWise: 'PrincipalDashboard/ReadFeeCollectionDetailsClassWise',
    ReadFeeCollectionDetailsStudentWise: 'PrincipalDashboard/ReadFeeCollectionDetailsStudentWise',
    ReadScholarshipDetailsCourseWise: 'PrincipalDashboard/ReadScholarshipDetailsCourseWise',
    ReadScholarshipDetailsSemWise: 'PrincipalDashboard/ReadScholarshipDetailsSemWise',
    ReadScholarshipDetailsStudentWise: 'PrincipalDashboard/ReadScholarshipDetailsStudentWise',
    ReadAdmissionAnalysisByQuota: 'PrincipalDashboard/ReadAdmissionAnalysisByQuota',
    ReadAdmissionAnalysisByQuotaAndGender: 'PrincipalDashboard/ReadAdmissionAnalysisByQuotaAndGender',
    ReadAdmissionAnalysisByQuotaWiseVacancy: 'PrincipalDashboard/ReadAdmissionAnalysisByQuotaWiseVacancy',
    ReadAdmissionAnalysisByDistrict: 'PrincipalDashboard/ReadAdmissionAnalysisByDistrict',
    ReadProfessionalDevelopmentWorkshopsEnteredStaffs:'PrincipalDashboard/ReadProfessionalDevelopmentWorkshopsEnteredStaffs',
    ReadStaffProfessionalDevelopmentWorkshops:'PrincipalDashboard/ReadStaffProfessionalDevelopmentWorkshops',
    ReadStudentEnrollmentDetailsForPriDB:'PrincipalDashboard/ReadStudentEnrollmentDetailsForPriDB',
    ReadStudentPersonalDetailsForPriDB:'PrincipalDashboard/ReadStudentPersonalDetailsForPriDB',
    ReadStudentAcademicsDetailsForPriDB:'PrincipalDashboard/ReadStudentAcademicsDetailsForPriDB',
    ReadStudentOtherDetailsForPriDB:'PrincipalDashboard/ReadStudentOtherDetailsForPriDB',
    ReadStaffProfileDataForPriDB:'PrincipalDashboard/ReadStaffProfileDataForPriDB',
    ReadStaffPersonalDataForPriDB:'PrincipalDashboard/ReadStaffPersonalDataForPriDB',
    ReadLowAttendanceStudentDetails:'PrincipalDashboard/ReadLowAttendanceStudentDetails',
    ReadAverageStudentAttendance:'PrincipalDashboard/ReadAverageStudentAttendance',
    ReadAcademicPerformancePaperWise:'PrincipalDashboard/ReadAcademicPerformancePaperWise',
    ReadAcademicPerformanceClassWise:'PrincipalDashboard/ReadAcademicPerformanceClassWise',
    ReadAcademicPerformanceDepartmentWise:'PrincipalDashboard/ReadAcademicPerformanceDepartmentWise',
    ReadPassFailPerSemesterWiseYearly:'PrincipalDashboard/ReadPassFailPerSemesterWiseYearly',
    ReadLowPerformingStudents:'PrincipalDashboard/ReadLowPerformingStudents',
    ReadStudentsAttendanceWithPerformance:'PrincipalDashboard/ReadStudentsAttendanceWithPerformance',
    ReadFailRiskStudents:'PrincipalDashboard/ReadFailRiskStudents',
    ReadFailRiskStudentsFailedPaperDetails:'PrincipalDashboard/ReadFailRiskStudentsFailedPaperDetails',
    ReadPaperByDepartmentIDForPRiDB:'PrincipalDashboard/ReadPaperByDepartmentIDForPRiDB',
    SendBulkEmail:'PrincipalDashboard/SendBulkEmail',
    ReadStudentFeeSummarySemesterWiseForPriDB:'PrincipalDashboard/ReadStudentFeeSummarySemesterWiseForPriDB',
    ReadStudentFeeDetailsBySemesterYearStudentIDForPriDB:'PrincipalDashboard/ReadStudentFeeDetailsBySemesterYearStudentIDForPriDB'
  },

  Placement: {
    ReadPsychometricTest: 'Placement/ReadPsychometricTest',
    UpdatePsychometricTest: 'Placement/UpdatePsychometricTest',
    DeletePsychometricTest: 'Placement/DeletePsychometricTest',
    ReadPsychometricSections: 'Placement/ReadPsychometricSections',
    UpdatePsychometricSections: 'Placement/UpdatePsychometricSections',
    DeletePsychometricSections: 'Placement/DeletePsychometricSections',
    ReadPsychometricQuestions: 'Placement/ReadPsychometricQuestions',
    UpdatePsychometricQuestions: 'Placement/UpdatePsychometricQuestions',
    DeletePsychometricQuestions: 'Placement/DeletePsychometricQuestions',
    ReadPlacementRecruiters: 'Placement/ReadPlacementRecruiters',
    UpdatePlacementRecruiters: 'Placement/UpdatePlacementRecruiters',
    DeletePlacementRecruiters: 'Placement/DeletePlacementRecruiters',
    ReadPlacementMembers: 'Placement/ReadPlacementMembers',
    ReadUsersForPlacementMembers: 'Placement/ReadUsersForPlacementMembers',
    UpdatePlacementMembers: 'Placement/UpdatePlacementMembers',
    DeletePlacementMembers: 'Placement/DeletePlacementMembers',
    ReadPlacementJobOffered: 'Placement/ReadPlacementJobOffered',
    UpdatePlacementJobOffered: 'Placement/UpdatePlacementJobOffered',
    DeletePlacementJobOffered: 'Placement/DeletePlacementJobOffered',
    ReadPlacementEligibilitySettings: 'Placement/ReadPlacementEligibilitySettings',
    UpdatePlacementEligibilitySettings: 'Placement/UpdatePlacementEligibilitySettings',
    DeletePlacementEligibilitySettings: 'Placement/DeletePlacementEligibilitySettings',
    ReadPlacementJobsBasedOnRecruiters: 'Placement/ReadPlacementJobsBasedOnRecruiters',
    ReadStudentPlacements: 'Placement/ReadStudentPlacements',
    ReadStudentsForPsychometricResult: 'Placement/ReadStudentsForPsychometricResult',
    UpdateStudentPlacementStatus: 'Placement/UpdateStudentPlacementStatus',
    SendEmail: 'Placement/SendEmail',
    UpdatePsychometricTestStatus: 'Placement/UpdatePsychometricTestStatus',
    UpdatePsychometricSectionStatus: 'Placement/UpdatePsychometricSectionStatus',
    UpdatePsychometricQuestionStatus: 'Placement/UpdatePsychometricQuestionStatus',
    ReadJobOfferedCourses: 'Placement/ReadJobOfferedCourses',
    ReadJobOfferedStudentsWithEligibleDetails: 'Placement/ReadJobOfferedStudentsWithEligibleDetails',
    UpdateStudentsPlacementApplications: 'Placement/UpdateStudentsPlacementApplications',

  },
  EvaluationItemDetail: {
    ReadEvaluationItemDetails: 'EvaluationItemDetail/ReadEvaluationItemDetails',
    CreateEvaluationItemAndKeyDetails: 'EvaluationItemDetail/CreateEvaluationItemAndKeyDetails'
  },
  MobileAppAccess: {
    DeleteMobileGroup: 'MobileAppAccess/DeleteMobileGroup',
    DeleteMobileGroupUsers: 'MobileAppAccess/DeleteMobileGroupUsers',
    ReadNonMobileAppGroupUsers: 'MobileAppAccess/ReadNonMobileAppGroupUsers',
    ReadTypeForMobileGroups: 'MobileAppAccess/ReadTypeForMobileGroups',
    UpdateMobileGroupUsers: 'MobileAppAccess/UpdateMobileGroupUsers',
    ReadMobileAppGroupUsers: 'MobileAppAccess/ReadMobileAppGroupUsers',
    Read: 'MobileAppAccess/Read',
    Update: 'MobileAppAccess/Update',
    ReadNonMobileAppAccessUsers: 'MobileAppAccess/ReadNonMobileAppAccessUsers',
    DeleteMobileAppAccess: 'MobileAppAccess/Delete',
  },
  Utility: {
    UpdateStudentDOBInWord: 'Utility/UpdateStudentDOBInWord',
    UpdateAcademicYearStartAndEndDate: 'Utility/UpdateAcademicYearStartAndEndDate',
    UpdateStudentPhotoSaveFromRegNoSettings: 'Utility/UpdateStudentPhotoSaveFromRegNoSettings',
    UpdateStudentSortOrder: 'Utility/UpdateStudentSortOrder',
    UpdateAllStudentRunningStatusDate: 'Utility/UpdateAllStudentRunningStatusDate',
    UpdateStudentsRunningStatusLog: 'Utility/UpdateStudentsRunningStatusLog',
    UpdateClassActiveAndInactiveBasedOnDate: 'Utility/UpdateClassActiveAndInactiveBasedOnDate',
    UpdateStudentRunningStatusDateInAClass: 'Utility/UpdateStudentRunningStatusDateInAClass',
    DeleteStudent: 'Utility/DeleteStudent'
  },
  InternalMarkEntry: {
    ReadInternalMarkedPaperDetailsForConsolidatedGeneration: 'InternalMarkEntry/ReadInternalMarkedPaperDetailsForConsolidatedGeneration',
    GenerateConsolidation: 'InternalMarkEntry/GenerateConsolidation',
    ReadInternalExam: 'InternalMarkEntry/ReadInternalExam',
    UpdateInternalExam: 'InternalMarkEntry/UpdateInternalExam',
    DeleteInternalExam: 'InternalMarkEntry/DeleteInternalExam',
    UpdateConsolidatedMarkEntry: 'InternalMarkEntry/UpdateConsolidatedMarkEntry',
    ReadInternalAssessmentMarkEntrySeries: 'InternalMarkEntry/ReadInternalAssessmentMarkEntrySeries',

  },
  CommitteeMembers: {
    ReadCommitteeMembers: 'CommitteeMembers/ReadCommitteeMembers',
    UpdateCommitteeMembers: 'CommitteeMembers/UpdateCommitteeMembers',

  },
  Committees: {
    ReadCommittees: 'Committees/ReadCommittees',
    UpdateCommittees: 'Committees/UpdateCommittees',
    DeleteCommittees: 'Committees/DeleteCommittees',
    UpdateCommitteeMemberHistory: 'Committees/UpdateCommitteeMemberHistory',
    DeleteCommitteeMemberHistory: 'Committees/DeleteCommitteeMemberHistory',
    ReadMeetingMinutes: 'Committees/ReadMeetingMinutes',
    UpdateMeetingMinutes: 'Committees/UpdateMeetingMinutes',
    DeleteMeetingMinutes: 'Committees/DeleteMeetingMinutes',
    CheckRoomAvailability: 'Committees/CheckRoomAvailability',
    UpdateMeetingMinuteStaff: 'Committees/UpdateMeetingMinuteStaff',
    SendEmail: 'Committees/SendEmail',
    UpdateMeetingMinuteStaffAttendance: 'Committees/UpdateMeetingMinuteStaffAttendance',
    ReadMeetingMinuteDutyDetail: 'Committees/ReadMeetingMinuteDutyDetail',
    UpdateMeetingMinuteDuty: 'Committees/UpdateMeetingMinuteDuty',
    UpdateMeetingMinuteAttendance: 'Committees/UpdateMeetingMinuteAttendance',
    ReadCommitteeByUserID: 'Committees/ReadCommitteeByUserID',
    ReadMinutesbyUserID: 'Committees/ReadMinutesbyUserID',
    UpdateMeetingMinutesDuty: 'Committees/UpdateMeetingMinutesDuty'
  },
  Website: {
    ReadStudentProfileUrlDetails: 'Website/ReadStudentProfileUrlDetails',
    UpdateStudentProfileUrl: 'Website/UpdateStudentProfileUrl',
    ReadStudentPsychometricReportUrlDetails: 'Website/ReadStudentPsychometricReportUrlDetails',
    UpdateStudentPsychometricReportUrl: 'Website/UpdateStudentPsychometricReportUrl'
  },
  TransportationFee: {
    ReadTransportationFeeSettingsData: 'TransportationFee/ReadTransportationFeeSettingsData',
    ReadTransportationFeeCategory:'TransportationFee/ReadTransportationFeeCategory',
    UpdateTransportationFeeCategory:'TransportationFee/UpdateTransportationFeeCategory',
    DeleteTransportationFeeCategory:'TransportationFee/DeleteTransportationFeeCategory',
    ReadTransportationFeeItems:'TransportationFee/ReadTransportationFeeItems',
    UpdateTransportationFeeItems:'TransportationFee/UpdateTransportationFeeItems',
    DeleteTransportationFeeItems:'TransportationFee/DeleteTransportationFeeItems',
    ReadTransportationInstallment:'TransportationFee/ReadTransportationInstallment',
    UpdateTransportationInstallment:'TransportationFee/UpdateTransportationInstallment',
    DeleteTransportationInstallment:'TransportationFee/DeleteTransportationInstallment',
    ReadStudentsForTransportationFeeDemanding:'TransportationFee/ReadStudentsForTransportationFeeDemanding',
    ReadTransportationFeeDemandingStudents:'TransportationFee/ReadTransportationFeeDemandingStudents',
    UpdateTransportationDemand:'TransportationFee/UpdateTransportationDemand',
    DeleteTransportationDemand:'TransportationFee/DeleteTransportationDemand',
    ReadStudentTransportationFeeCollectionBalance:'TransportationFee/ReadStudentTransportationFeeCollectionBalance',
    TransportationFeeCollection:'TransportationFee/TransportationFeeCollection',
    ReadTransportationFeeCollectionMaster:'TransportationFee/ReadTransportationFeeCollectionMaster',
    DeleteTransportationCollection:'TransportationFee/DeleteTransportationCollection',


  },
  BoardingPoint: {
    ReadBoardingPoint: 'BoardingPoint/ReadBoardingPoint',
    UpdateBoardingPoint: 'BoardingPoint/UpdateBoardingPoint',
    DeleteBoardingPoint: 'BoardingPoint/DeleteBoardingPoint',
  },
  Vendor: {
    ReadVendor: 'Vendor/ReadVendor',
    UpdateVendor: 'Vendor/UpdateVendor',
    DeleteVendor: 'Vendor/DeleteVendor',
  },
  Vehicle: {
    ReadVehicle: 'Vehicle/ReadVehicle',
    UpdateVehicle: 'Vehicle/UpdateVehicle',
    DeleteVehicle: 'Vehicle/DeleteVehicle',
    ReadVehicleDocDetails: 'Vehicle/ReadVehicleDocDetails',
    UpdateVehicleDocDetails: 'Vehicle/UpdateVehicleDocDetails',
    DeleteVehicleDocDetails: 'Vehicle/DeleteVehicleDocDetails',
    ReadVehicleExpense: 'Vehicle/ReadVehicleExpense',
    UpdateVehicleExpense: 'Vehicle/UpdateVehicleExpense',
    DeleteVehicleExpense: 'Vehicle/DeleteVehicleExpense',
  },
  VehicleDriverProfile: {
    ReadVehicleDriver: 'VehicleDriverProfile/ReadVehicleDriver',
    UpdateVehicleDriver: 'VehicleDriverProfile/UpdateVehicleDriver',
    DeleteVehicleDriver: 'VehicleDriverProfile/DeleteVehicleDriver',
  },
   ExamControllerDashboardController:{
    ReadExamTimetable: 'ExamControllerDashboardController/ReadExamTimetable',
  },
  ExamControllerDashboard:{
    ReadExamProgressStatusCount: 'ExamControllerDashboardController/ReadExamProgressStatusCount',
    ReadExamProgressStatusCountDetails: 'ExamControllerDashboardController/ReadExamProgressStatusCountDetails',
  },
  StudentMaster:{
    SearchByKeyword: 'StudentMaster/SearchByKeyword',
    ReadByCourseID: 'StudentMaster/ReadByCourseID',
  },
  PlacementDashboard:{
    ReadMaxAndAvgPackage: 'PlacementDashboard/ReadMaxAndAvgPackage',
    ReadStudentPlacementDetails: 'PlacementDashboard/ReadStudentPlacementDetails',
    ReadStudentPlacementStatusCount: 'PlacementDashboard/ReadStudentPlacementStatusCount',
    ReadStudentPlacementCount: 'PlacementDashboard/ReadStudentPlacementCount',
    ReadCompanyDetails: 'PlacementDashboard/ReadCompanyDetails',
    ReadCompanyStatusCount: 'PlacementDashboard/ReadCompanyStatusCount',
    ReadCompanyCount: 'PlacementDashboard/ReadCompanyCount',
    ReadStudentPlacementEligibleCount: 'PlacementDashboard/ReadStudentPlacementEligibleCount',
    ReadStudentPlacementEligibleDetails: 'PlacementDashboard/ReadStudentPlacementEligibleDetails',
  },

  Calendar: {
    ReadCalendarMaxDateAndMinDate: 'Calendar/ReadCalendarMaxDateAndMinDate',
  },

  StudentLeaveDetails: {
    ReadStudentAttendanceClaimDetails: 'StudentLeaveDetails/ReadStudentAttendanceClaimDetails',
    UpdateStudentAttendanceClaim: 'StudentLeaveDetails/UpdateStudentAttendanceClaim',
    DeleteStudentAttendanceClaim: 'StudentLeaveDetails/DeleteStudentAttendanceClaim',
  },

  StudentClubRegistration: {
    ReadClubRegisteredStudents: 'StudentClubRegistration/ReadClubRegisteredStudents',
  },

  PapersInClass: {
    ReadPaperinClass: 'PapersInClass/ReadPaperinClass',
  },

  InternalAssessmentItems:{
    ReadAssessmentsByClassID: 'InternalAssessmentItems/ReadAssessmentsByClassID',
  },
  

};




export enum AIapiBaseURLs {
  CourseRecommendation = "https://course-recommendation.meshilogic.com"
}

export enum AIUrlEndPoints {


}